export default __webpack_public_path__ + "static/media/Rectangle.9d0dce36.svg";